import {NgModule} from '@angular/core';
import {ProgressBarComponent} from './progress-bar/progress-bar';
import {CircleProgressBarComponent} from './circle-progress-bar/circle-progress-bar';
import {ThinProgressBarComponent} from './thin-progress-bar/thin-progress-bar';
import {UpcEpcGridComponent} from './upc-epc-grid/upc-epc-grid';
import {TranslateModule} from '@ngx-translate/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicPageModule} from 'ionic-angular';
import {ValidateInputPipe} from "../pipes/validate-input/validate-input";
import {DirectivesModule} from "../directives/directives.module";
import { TagInformationComponent } from './tag-information/tag-information';

@NgModule({
  declarations: [
    ProgressBarComponent,
    CircleProgressBarComponent,
    ThinProgressBarComponent,
    UpcEpcGridComponent,
    TagInformationComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(UpcEpcGridComponent),
    DirectivesModule
  ],
  providers: [
    ValidateInputPipe
  ],
  exports: [
    ProgressBarComponent,
    CircleProgressBarComponent,
    ThinProgressBarComponent,
    UpcEpcGridComponent,
    TagInformationComponent]
})
export class ComponentsModule {
  static forRoot() {

  }
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts